var Module = {
    name: 'select',

    init: function (item, options = null, callback = null, errCallback = null) {
        if (item.length === 0) {
            return;
        }

        let minimunSearchValue = 0;
        if (item.hasClass('no-search')) {
            minimunSearchValue = Infinity;
        }

        let select2InitData = {
            escapeMarkup: function(markup) {
                return markup;
            },
            dropdownCssClass: ':all:',
            minimumResultsForSearch: minimunSearchValue
        };

        if (item.hasClass('select2-phone-mask')) {
            select2InitData.dropdownAutoWidth = true;
        }

        if (item.hasClass('select2-tags')) {
            select2InitData.tags = true;
            if (
                item.attr('data-select2-tags-min') !== undefined ||
                item.attr('data-select2-tags-max') !== undefined)
            {
                let min = item.attr('data-select2-tags-min');
                let max = item.attr('data-select2-tags-max');

                select2InitData.createTag = function (params) {
                    var term = $.trim(params.term);
                    min = parseInt(min);
                    max = parseInt(max);
                    term = parseInt(term);
                    if (!Number.isInteger(term) || term < min) return null;
                    if (term > max ) term = max;
                    return {
                      id: term,
                      text: term,
                      newTag: true
                    }
                }
            }
        }

        // fix search input in profile popup.
        let profilePopup = $('.es-popup:visible');
        if(profilePopup.length > 0) {
            select2InitData.dropdownParent = profilePopup;
        }

        if (options) {
            select2InitData.data = options;
            if (item.hasClass('select2-hidden-accessible')) {
                item.select2('destroy');
                item.empty();
            }
            return item.select2(select2InitData);
        }

        let url = item.data('url')
        if (url) {
            select2InitData.ajax = {
                url: function () {
                    return url;
                },
                type: 'get',
                delay: 250,
                cache: true,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page || 1
                    };
                },
                success: function (response) {
                    if (callback && typeof(callback) == "function") {
                        callback(response)
                    }
                },
                error: function (response) {
                    if (errCallback && typeof(errCallback) == "function") {
                        errCallback(response)
                    }
                }
            };
        }
        return item.select2(select2InitData);
    }
}

module.exports = Module
